import { Serializable } from '@/models/core/serializable';

export class CheckStudentDifferencesResult implements Serializable<CheckStudentDifferencesResult> {
  registrationCount?: number;
  checkErrors: CheckErrorData[] = [];
  duplicateNameDifferences: DuplicateNameDifference[] = [];
  studentDifferencesNameOrMailAddress: StudentDifference[] = [];
  studentDifferencesOthers: StudentDifference[] = [];
  code?: number;
  reason?: string;

  deserialize(input: any): CheckStudentDifferencesResult {
    this.registrationCount = input.registrationCount;
    this.checkErrors = input.checkErrors.map((checkError: CheckErrorData) => new CheckErrorData().deserialize(checkError));
    this.duplicateNameDifferences = input.duplicateNameDifferences.map((duplicateNameDifference: DuplicateNameDifference) => new DuplicateNameDifference().deserialize(duplicateNameDifference));
    this.studentDifferencesNameOrMailAddress = input.studentDifferencesNameOrMailAddress.map((studentDifference: StudentDifference) => new StudentDifference().deserialize(studentDifference));
    this.studentDifferencesOthers = input.studentDifferencesOthers.map((studentDifference: StudentDifference) => new StudentDifference().deserialize(studentDifference));
    this.code = input.code;
    this.reason = input.reason;
    return this;
  }
}

export class CheckErrorData implements Serializable<CheckErrorData> {
  rowNum: number;
  studentNumber: string;
  errorMessageMain: string;
  errorMessageSub: string;

  deserialize(input: any): CheckErrorData {
    this.rowNum = input.rowNum;
    this.studentNumber = input.studentNumber;
    this.errorMessageMain = input.errorMessageMain;
    this.errorMessageSub = input.errorMessageSub;
    return this;
  }
}

export class DuplicateNameDifference implements Serializable<DuplicateNameDifference> {
  checkType: number;
  newData: DuplicateNameDifferenceData;
  currentData: DuplicateNameDifferenceData;

  deserialize(input: any): DuplicateNameDifference {
    this.checkType = input.checkType;
    this.newData = new DuplicateNameDifferenceData().deserialize(input.newData);
    this.currentData = new DuplicateNameDifferenceData().deserialize(input.currentData);
    return this;
  }
}

export class DuplicateNameDifferenceData implements Serializable<DuplicateNameDifferenceData> {
  rowNum: number;
  studentNumber: string;
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  grade: number;
  schoolClassName: string;
  registrationPlace: string;

  deserialize(input: any): DuplicateNameDifferenceData {
    this.rowNum = input.rowNum;
    this.studentNumber = input.studentNumber;
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.lastNameKana = input.lastNameKana;
    this.firstNameKana = input.firstNameKana;
    this.grade = input.grade;
    this.schoolClassName = input.schoolClassName;
    this.registrationPlace = input.registrationPlace;
    return this;
  }
}

export class StudentDifference implements Serializable<StudentDifference> {
  newData: StudentDifferenceData;
  currentData: StudentDifferenceData;
  equalCheck: StudentEqualCheck;

  deserialize(input: any): StudentDifference {
    this.newData = new StudentDifferenceData().deserialize(input.newData);
    this.currentData = new StudentDifferenceData().deserialize(input.currentData);
    this.equalCheck = new StudentEqualCheck().deserialize(input.equalCheck);
    return this;
  }

  // 画面表示する際に、現新データを2行にわけて表示させるため、変換する
  get changeForDisplay(): StudentDifferenceDataForDisplay[] {
    return [
      new StudentDifferenceDataForDisplay().deserialize({ isNewData: false, studentDifferenceData: this.currentData, studentEqualCheck: this.equalCheck }),
      new StudentDifferenceDataForDisplay().deserialize({ isNewData: true, studentDifferenceData: this.newData, studentEqualCheck: this.equalCheck }),
    ];
  }
}

export class StudentDifferenceData implements Serializable<StudentDifferenceData> {
  rowNum: number;
  studentNumber: string;
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  grade: number;
  schoolClassName: string;
  manageNumber: number;
  tag: string[];
  priorityTagName: string;
  contactEmail: string;

  deserialize(input: any): StudentDifferenceData {
    this.rowNum = input.rowNum;
    this.studentNumber = input.studentNumber;
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.lastNameKana = input.lastNameKana;
    this.firstNameKana = input.firstNameKana;
    this.grade = input.grade;
    this.schoolClassName = input.schoolClassName;
    this.manageNumber = input.manageNumber;
    this.tag = input.tag;
    this.priorityTagName = input.priorityTagName;
    this.contactEmail = input.contactEmail;
    return this;
  }
}

export class StudentEqualCheck implements Serializable<StudentEqualCheck> {
  // rowNumは不要
  studentNumber: boolean;
  lastName: boolean;
  firstName: boolean;
  lastNameKana: boolean;
  firstNameKana: boolean;
  grade: boolean;
  schoolClassName: boolean;
  manageNumber: boolean;
  tag: boolean;
  priorityTagName: boolean;
  contactEmail: boolean;

  deserialize(input: any): StudentEqualCheck {
    this.studentNumber = input.studentNumber;
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.lastNameKana = input.lastNameKana;
    this.firstNameKana = input.firstNameKana;
    this.grade = input.grade;
    this.schoolClassName = input.schoolClassName;
    this.manageNumber = input.manageNumber;
    this.tag = input.tag;
    this.priorityTagName = input.priorityTagName;
    this.contactEmail = input.contactEmail;
    return this;
  }
}

export class StudentDifferenceDataForDisplay implements Serializable<StudentDifferenceDataForDisplay> {
  isNewData: boolean;
  studentDifferenceData: StudentDifferenceData;
  studentEqualCheck: StudentEqualCheck;

  deserialize(input: any): StudentDifferenceDataForDisplay {
    this.isNewData = input.isNewData;
    this.studentDifferenceData = input.studentDifferenceData;
    this.studentEqualCheck = input.studentEqualCheck;
    return this;
  }
}
